import { useMemo } from 'react';
import { css } from '@emotion/core';
import useTheme from './useTheme';

/*
 * Returns the classes object
 */

/* eslint-disable react-hooks/exhaustive-deps */
export default function useStyles(styleFunc, data = {}) {
	const theme = useTheme();
	return useMemo(() => styleFunc({ css, theme, data }), [styleFunc, theme, ...Object.values(data)]);
}
/* eslint-enable react-hooks/exhaustive-deps */
